const API_BASE = '/api';

import { ReviewLogListResponse, ReviewLog } from '../types/reviewLog';
export const api = {
    login: async (credentials: any) => {
        const res = await fetch(`${API_BASE}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(credentials),
        });
        if (!res.ok) throw new Error('Login failed');
        return res.json();
    },

    getMemos: async (params: any = {}) => {
        const cleanParams: Record<string, string> = {};
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== 'undefined') {
                cleanParams[key] = String(value);
            }
        });
        const searchParams = new URLSearchParams(cleanParams);
        const res = await fetch(`${API_BASE}/memos?${searchParams}`);
        if (!res.ok) throw new Error('Failed to fetch memos');
        return res.json();
    },

    getMemoStats: async (): Promise<{ data: { date: string; count: number }[] }> => {
        const res = await fetch(`${API_BASE}/memos/stats`);
        if (!res.ok) throw new Error('Failed to fetch memo stats');
        return res.json();
    },

    getMemoDates: async (): Promise<{ data: string[] }> => {
        const res = await fetch(`${API_BASE}/memos/dates`);
        if (!res.ok) throw new Error('Failed to fetch memo dates');
        return res.json();
    },

    getMemoTypes: async (): Promise<{ data: string[] }> => {
        const res = await fetch(`${API_BASE}/memos/types`);
        if (!res.ok) throw new Error('Failed to fetch memo types');
        return res.json();
    },

    getEntities: async (): Promise<{ data: any[] }> => {
        const res = await fetch(`${API_BASE}/entities`);
        if (!res.ok) throw new Error('Failed to fetch entities');
        return res.json();
    },

    createEntity: async (data: any) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/entities`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error('Failed to create entity');
        return res.json();
    },

    updateEntity: async (id: string, data: any) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/entities/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error('Failed to update entity');
        return res.json();
    },

    deleteEntity: async (id: string) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/entities/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!res.ok) throw new Error('Failed to delete entity');
        return res.json();
    },

    getTags: async () => {
        // Mock implementation for now
        return { data: ['TODO', 'IMPULSE', 'EVENT', 'OBSERVATION', 'KNOWLEDGE', 'INSIGHT', 'QUESTION', 'RESOURCE'] };
    },

    createMemo: async (data: any) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/memos`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error('Failed to create memo');
        return res.json();
    },

    search: async (query: string) => {
        const res = await fetch(`${API_BASE}/search?q=${encodeURIComponent(query)}`);
        if (!res.ok) throw new Error('Search failed');
        return res.json();
    },

    updateMemo: async (id: string, data: any) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/memos/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error('Failed to update memo');
        return res.json();
    },

    deleteMemo: async (id: string) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/memos/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!res.ok) throw new Error('Failed to delete memo');
        return res.json();
    },

    getReviewLogs: async (params: { page?: number; limit?: number } = {}): Promise<ReviewLogListResponse> => {
        const searchParams = new URLSearchParams({
            page: String(params.page || 1),
            limit: String(params.limit || 10),
        });
        const res = await fetch(`${API_BASE}/review-logs?${searchParams}`);
        if (!res.ok) throw new Error('Failed to fetch review logs');
        return res.json();
    },

    createReviewLog: async (data: any) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/review-logs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error('Failed to create review log');
        return res.json();
    },

    updateReviewLog: async (id: string, data: any) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/review-logs/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (!res.ok) throw new Error('Failed to update review log');
        return res.json();
    }
};
